import React from "react";
import { Outlet } from "react-router-dom"; 
import Footer from "../components/Footer";

const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen bg-castle-cream-200"> 
      <main className="flex-grow" role="main">
        <Outlet /> 
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
